import { render, staticRenderFns } from "./TranslationTooltip.vue?vue&type=template&id=0a1df4f1&"
import script from "./TranslationTooltip.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TranslationTooltip.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports